export default IconStackBack => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stack-back" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 8l8 4l8 -4l-8 -4z" />
  <path d="M12 16l-4 -2l-4 2l8 4l8 -4l-4 -2l-4 2z" fill="currentColor" />
  <path d="M8 10l-4 2l4 2m8 0l4 -2l-4 -2" />
</svg>`;